import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DAYS = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
const MONTHS = [
  'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
  'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
];

const PRIORITY_COLORS = {
  urgent: 'var(--c-coral)', high: 'var(--c-warning)', medium: 'var(--c-blue-500)', low: 'var(--text-faint)'
};

function toDateKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default function TasksCalendar() {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [cursor, setCursor] = useState(new Date());
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const year = cursor.getFullYear();
  const month = cursor.getMonth();

  useEffect(() => {
    const from = toDateKey(new Date(year, month, 1));
    const to = toDateKey(new Date(year, month + 1, 0));
    setLoading(true);
    api(`/tasks/calendar?from=${from}&to=${to}`)
      .then(setTasks)
      .catch(() => setTasks([]))
      .finally(() => setLoading(false));
  }, [year, month]);

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weeks = [];
  let cell = 1 - firstDay;
  while (cell <= daysInMonth) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      week.push(cell > 0 && cell <= daysInMonth ? new Date(year, month, cell) : null);
      cell++;
    }
    weeks.push(week);
  }

  const byDate = tasks.reduce((acc, t) => {
    const key = t.due_date?.slice(0, 10);
    if (!key) return acc;
    (acc[key] = acc[key] || []).push(t);
    return acc;
  }, {});

  const todayKey = toDateKey(new Date());

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button className="btn btn-outline btn-sm" onClick={() => setCursor(new Date(year, month - 1))}>◀</button>
          <span style={{ fontWeight: 600, fontSize: 16, minWidth: 140, textAlign: 'center' }}>
            {MONTHS[month]} {year}
          </span>
          <button className="btn btn-outline btn-sm" onClick={() => setCursor(new Date(year, month + 1))}>▶</button>
          <button className="btn btn-outline btn-sm" onClick={() => setCursor(new Date())}>اليوم</button>
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          {loading ? 'جاري التحميل...' : `${tasks.length} مهمة`}
        </div>
      </div>

      <div className="calendar">
        <div className="calendar-header">
          {DAYS.map(d => <div key={d} className="calendar-day-name">{d}</div>)}
        </div>
        <div className="calendar-body">
          {weeks.map((week, wi) => (
            <div key={wi} className="calendar-week">
              {week.map((day, di) => {
                if (!day) return <div key={di} className="calendar-cell empty" />;
                const key = toDateKey(day);
                const dayTasks = byDate[key] || [];
                const isToday = key === todayKey;
                return (
                  <div key={di} className={`calendar-cell ${isToday ? 'today' : ''}`}>
                    <div className="calendar-date">{day.getDate()}</div>
                    <div className="calendar-tasks">
                      {dayTasks.slice(0, 3).map(t => (
                        <div
                          key={t.id}
                          className="calendar-task"
                          onClick={() => navigate(`/tasks/${t.id}`)}
                          style={{ borderRightColor: PRIORITY_COLORS[t.priority] || 'var(--text-faint)' }}
                          title={t.title}
                        >
                          {t.title}
                        </div>
                      ))}
                      {dayTasks.length > 3 && (
                        <div className="calendar-more">+{dayTasks.length - 3} أخرى</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
